import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
// import Link from "@mui/material/Link";

function BreadUtilizador() {
  return (
    <Breadcrumbs
      separator="›"
      aria-label="breadcrumb"
      style={{ marginBottom: '10px', marginTop: '5px' }}
    >
      <Link to="/app" color="textPrimary">
        Inicio
      </Link>
      <Link to="/app/administracao/utilizadores" color="textPrimary">
        Lista de Utilizadores
      </Link>
      <Typography color="textPrimary">Utilizador</Typography>
    </Breadcrumbs>
  );
}
export default BreadUtilizador;
